import { Component, EventEmitter, Input, Output, OnInit, ViewChild, ElementRef} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgIf, NgForOf } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ApiService } from '../../../app/services/api.service';
import { AlertService } from '../../../app/services/alert.service';
import { Constants } from "../../../app/models/Constants";
import { DropDownComponent } from "../drop-down/drop-down.component";

// SKS24AUG24 Component decorator defines the metadata for the EmailPopupComponent, including its selector, template, styles, and imported modules.
@Component({
  selector: 'app-email-popup',
  templateUrl: './email-popup.component.html',
  styleUrls: ['./email-popup.component.css'],
  standalone: true,
  imports: [FormsModule, NgIf, NgForOf, DropDownComponent],
})
// SKS24AUG24 EmailPopupComponent class implements OnInit lifecycle hook and is responsible for handling email-related functionality, including template selection, formatting, and file attachments.
export class EmailPopupComponent implements OnInit {
  @ViewChild('editorContent') editorContent!: ElementRef; // Using non-null assertion
  // SKS24AUG24 ViewChild decorator is used to reference the HTML element with the 'editor' id.
  @ViewChild('editor') editor!: ElementRef<HTMLDivElement>;
  // SKS24AUG24 Input decorator allows passing data to the component from its parent.
  @Input() emailData: any = {
    emailId: '',
    to: '',
    cc: '',
    subject: '',
    content: '',
    attachments: [],
    bulkemail: '',
    status:''
  };
  // SKS24AUG24 Output decorator creates custom events that can be listened to by parent components.
  @Output() close = new EventEmitter<void>();
  isDropdownOpen = false; // SKS24AUG24 Controls the visibility of the dropdown menu.
  templates: any[] = []; // SKS24AUG24 Stores email templates fetched from the server.
  successMessage = 'Template processed successfully!'; // SKS24AUG24 Success message displayed after processing a template.
  draft: any[] = [];
  selectedDraft: any = null;
  fileInput: any;
  eventValue: string | undefined; // To store the selected value
  option : Array<any> = [];
  templatename: string = 'Templates';
  // SKS24AUG24 Constructor injects necessary services such as HttpClient, ApiService, AlertService, and Renderer2.
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private alertService: AlertService ) {}

// SKS24AUG24 ngOnInit lifecycle hook fetches email templates when the component is initialized.
ngOnInit() {
  this.fetchTemplates();
  this.loadDraft();
}
loadDraft(): void {
    // SKS2SEP24  Check if bulk email is not selected, then proceed to fetch the draft email
    if (!this.emailData.bulkemail) {
      // SKS2SEP24  Make an HTTP GET request to fetch the draft email data
      this.apiService.fetchValue('/sendemail/getDraft').subscribe((data: any) => {
        this.draft = data;
      })
  }
}

  selectDraft(draft: any): void {
      this.selectedDraft = draft;
      this.emailData.emailId =this.selectedDraft.id;
      this.emailData.subject =this.selectedDraft.subject;
      this.emailData.content = this.selectedDraft.messageBody;
      this.emailData.attachments =this.selectedDraft.attachments;
      this.emailData.status =this.selectedDraft.status;
  }
  emittedValue(event: string): void {
    this.eventValue = event;
    this.selectTemplate(event); // Assuming you want to keep the original method to handle the selected value
  }
  // SKS24AUG24 toggleDropdown toggles the visibility of the dropdown menu.
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // SKS24AUG24 fetchTemplates method retrieves email templates from the server.
  fetchTemplates() {
    this.apiService.fetchValue('/emailtemplate/email-templates').subscribe((data: any) => {
      this.templates = data;
      this.option = this.templates.map(template => [
        template.name
      ]); 
    })
  }
  
  sendEmail(event: Event) {
    // SKS24AUG24 Check if the single email popup is open
    const editor = event.target as HTMLElement;
    const specificDiv = editor.querySelector('div.editor') as HTMLElement;
    this.emailData.content = specificDiv.innerHTML;
      console.log('single mail Sending email with details:', this.emailData);
      this.apiService.writeValue("post", `/sendemail`, this.emailData).subscribe({
        next: (response) => {
          console.log('Email sent successfully:', response);
          this.alertService.messageOnPass('success','Email sent successfully'); // SKS24AUG24 Show success message
        },
        error: (err: HttpErrorResponse) => {
          console.error('Error sending email:', err);
          this.alertService.messageOnPass('error', err); // SKS24AUG24 Handle the error case
        }
      });
    // SKS24AUG24 Close the email popup after sending the email(s)
    this.close.emit();
  } 

  saveDraft(draftData: any) {
    // SKS 24AUG24 Constructs the API URL for saving an email draft
    this.apiService.writeValue("post", `/sendemail/save-draft`, draftData).subscribe({
      next: (savedData) => {
      },
      error: (err: HttpErrorResponse) => {
        this.alertService.messageOnPass('error', err);
      }
    })
  } 
  downloadFile(data: Blob, filename: string): void {
    const url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a); // Append the link to the document body
    a.click(); // Simulate the click to trigger the download
    document.body.removeChild(a); // Remove the link after triggering download
    window.URL.revokeObjectURL(url); // Revoke the object URL after use
  }
  // SKS24AUG24 selectTemplate method processes the selected template and updates the email content.
  selectTemplate(event: any) {
    console.log(event)
    if(!this.emailData.bulkemail){
    const data = this.emailData.id;
    console.log("eventdata",event.data)
    // SKS24AUG24 Finds the selected template based on its ID.
    // const template = this.templates.find(template => template.name === event.data[0]);
    let templateId = event.data[0];
    const apiURL = `${Constants.SERVER_BASE_URL}/emailtemplate/process-template`;  // SKS 24AUG24 Endpoint to process the email template with given data
    this.http.post<any>(apiURL, { templateId, data }).subscribe({
        next: (response: { content: any; }) => {
          this.emailData.content = response.content;
          this.alertService.messageOnPass('success', this.successMessage);
        },
        error: (err: HttpErrorResponse) => {
          this.alertService.messageOnPass('error', err);
        }
      });
      // const params = new HttpParams({
      //   'fromObject':{
      //     'expense' : defaultData
      //   }
      // });
      // this.apiService.fetchValue('/approval',params).subscribe((data: any) => {
      //   if(this.isDevMode) console.log('History Data database', data);
      //   this.historyData = data;
      // })
    }else{
      // SKS24AUG24 Finds the selected template based on its ID.
      const template = this.templates.find(template => template.name === event.data[0]);
      this.emailData.content = template.body;
    }
    this.isDropdownOpen = false; // SKS24AUG24 Closes the dropdown menu after selecting a template.
  }

  // SKS24AUG24 format method executes formatting commands on the editor's content.
  format(command: string, value?: string) {
    document.execCommand(command, false, value || '');
  }
  // SKS24AUG24 onFileSelected method handles the selection of a file, converting it to a Base64 string and adding it to the attachments array.
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files.length > 0) {
        const file = input.files[0];
        if (file.size === 0) {
            console.error("Selected file is empty (0 kB). Please choose a different file.");
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            // Convert the file to a Base64 string
            const base64String = reader.result as string;
            // SKS24AUG24 Pushes the Base64 string to the attachments array.
            this.emailData.attachments.push({
                fileName: file.name,
                fileType: file.type,
                base64Data: base64String.split(',')[1] // Remove the "data:<type>;base64," part
            });
        };
        reader.onerror = (error) => {
            console.error('Error reading file:', error);
        };
        // SKS24AUG24 Reads the file as a data URL (Base64 string).
        reader.readAsDataURL(file);
    }
  }

  // SKS24AUG24 removeAttachment method removes an attachment from the attachments array based on its index.
  removeAttachment(index: number): void {
    this.emailData.attachments.splice(index, 1);
  }  
  // SKS24AUG24 changeFont method changes the font of the selected text in the editor.
  changeFont(event: Event) {
    const font = (event.target as HTMLSelectElement).value;
    this.format('fontName', font);
  }
  // SKS24AUG24 changeFontSize method changes the font size of the selected text in the editor.
  changeFontSize(event: Event) {
    const size = (event.target as HTMLSelectElement).value;
    this.format('fontSize', size);
  }
  // SKS24AUG24 changeColor method changes the color of the selected text in the editor.
  changeColor(event: Event) {
    const color = (event.target as HTMLInputElement).value;
    this.format('foreColor', color);
  }

  // SKS24AUG24 undo method undoes the last action performed in the editor.
  undo(event: MouseEvent) {
    this.format('undo');
    event.stopPropagation(); // SKS24AUG24 Prevents the event from propagating further.
  }

  // SKS24AUG24 redo method redoes the last undone action in the editor.
  redo(event: MouseEvent) {
    this.format('redo');
    event.stopPropagation(); // SKS24AUG24 Prevents the event from propagating further.
  }

  // SKS24AUG24 attachFile method opens a file input dialog, allowing the user to select multiple files and add them as attachments.
  attachFile() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.accept = 'application/pdf, image/*';

    fileInput.onchange = (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (input.files) {
        this.emailData.attachments.push(...Array.from(input.files));
      }
    };

    fileInput.click();
  }
  insertLink() {
    const url = prompt('Enter the URL');
    if (url) {
      this.format('createLink', url);
    }
  }

  insertEmoji() {
    const emoji = prompt('Enter emoji');
    if (emoji) {
      this.format('insertText', emoji);
    }
  }

  insertImage() {
    const url = prompt('Enter image URL');
    if (url) {
      this.format('insertImage', url);
    }
  }
  insertSignature() {
    const signature = 'Your Signature'; // Customize as needed
    this.format('insertText', signature);
  }
  // SKS24AUG24 closePopup method emits the close event to close the email popup.
  closePopup(form: NgForm,editor: any) {
    if(!this.emailData.bulkemail){
      this.emailData.to = form.value.to;
      this.emailData.cc = form.value.cc;
      this.emailData.subject = form.value.subject;
      this.emailData.content = this.editorContent.nativeElement.innerHTML;
      this.apiService.writeValue("post",`/sendemail/save-draft`,this.emailData).subscribe({
        next: (response) => {
          console.log('Data posted successfully:', response);
        },
        error: (err: HttpErrorResponse) => {
          console.error('Error posting data:', err);
        }
      });
    }
    this.close.emit();
  }
  discard() {
    // SKS2AUG24 - Check if the current email is a draft, and if so, delete it
    if (this.emailData.status === 'draft') {
        this.deleteDraft(this.emailData.emailId);
    }
    // SKS2AUG24 - Emit a close event to close the email editor or modal
    this.close.emit();
  }

  deleteDraft(id: number, event?: Event) {
      // SKS2AUG24 - Prevent the click event from triggering `selectDraft` if an event is provided
      if (event) {
        event.stopPropagation(); // Prevent the click event from triggering `selectDraft`
      }
      // SKS2AUG24 - Send a DELETE request to remove the draft from the server
      this.apiService.writeValue("delete", `/sendemail/delete-draft/${id}`, { id }).subscribe({
          next: () => {
              // SKS2AUG24 - Filter out the deleted draft from the local draft list
              this.draft = this.draft.filter(item => item.id !== id);
              // SKS2AUG24 - Clear the form if the deleted draft was selected
              if (this.selectedDraft && this.selectedDraft.id === id) {
                  this.selectedDraft = null;
              }
          },
          error: (err: HttpErrorResponse) => {
              console.error('Error deleting email:', err);
          }
      });
      // SKS2AUG24 - Reset the emailData if the deleted draft matches the current email
      if (id === this.emailData.emailId) {
          this.emailData = {
              emailId: '',
              cc: '',
              subject: `Subject here...`,
              content: `Dear Candidate,<br><br>I hope this email finds you well.<br> [Start typing your message here...].<br><br>Best regards,<br>[Your Name]`,
              template: 'Default Template',
              attachments: [], // SKS2AUG24 - Assuming resume is an array of files to be attached
          };
      }
  }

  deleteDrafticon() {
    // SKS2AUG24 - Check if an email ID exists, and if so, delete the corresponding draft
    if (this.emailData.emailId) {
        this.deleteDraft(this.emailData.emailId);
    }
    // SKS2AUG24 - Emit a close event to close the email editor or modal
    this.close.emit();
  }
}
